import React from "react";
import IconInfoCircle from "assets/icons/patientInformationIcon.svg";
import IconArrowDown from "assets/icons/expandAllIcon.svg";
import IconTick from "assets/icons/Green-Tick-Circle.svg";
import IconCross from "assets/icons/Red-Cross-Circle.svg";
import { Accordion, Card, Button } from "react-bootstrap";
import { getBodyParts } from "helpers/teleconsult.helper";
import { standardDate } from "helpers/common.helper";

function AccordianPatientInformation(data) {
  const getGender = (gender) => {
    if (gender == null){
      return "-";
    }else{
      switch (gender.toLowerCase()) {
        case "male":
        case "m":
          return "Male";
        case "female":
        case "f":
          return "Female";
        default:
          return "-";
      }
    }
  };

  const showIdentification =
    data.chat.user_info.identification_type === "nric" &&
    data.chat.user_info.identification_number;

  const additionalInfoRow = (question, answer, note) => {
    return (
      <div
        className={`info additional-info d-flex ${
          note ? "align-items-start" : "align-items-center"
        }`}
      >
        {answer ? (
          <img src={IconTick} alt="green-tick-icon" />
        ) : (
          <img src={IconCross} alt="red-cross-icon" />
        )}
        <div>
          <div className="question">{question}</div>
          {note && <div className="answer">{note}</div>}
        </div>
      </div>
    );
  };

  return (
    <>
      <Card className="patient-info card-accordian">
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" eventKey="0">
            <div className="header-title">
              <img
                src={IconInfoCircle}
                alt="icon-info-circle"
                className="title-icon"
              />
              <div className="title">Patient Information</div>
            </div>
            <div>
              <img src={IconArrowDown} alt="icon-arrow-down" />
            </div>
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body>
            {!data.chat.anonymous && (
              <React.Fragment>
                <div className="info-row">
                  <div className="label text-uppercase">Date of Birth</div>
                  <div className="info">
                    {standardDate(data.chat.user_info.date_of_birth) || "-"}
                  </div>
                </div>
                <div className="info-row">
                  <div className="label text-uppercase">Gender</div>
                  <div className="info text-capitalize">
                    {getGender(data.chat.user_info.sex) || "-"}
                  </div>
                </div>
                <div className="info-row">
                  <div className="label text-uppercase">NRIC</div>
                  <div className="info text-capitalize">
                    {showIdentification && (
                      <>
                        {data.chat.user_info.identification_number}
                        <img
                          src={IconTick}
                          alt="verified"
                          className="icon-tick"
                        />{" "}
                      </>
                    )}

                    {!showIdentification && <>-</>}
                  </div>
                </div>
                <div className="info-row">
                  <div className="label text-uppercase">Email</div>
                  <div className="info">{data.chat.user_info.email || "-"}</div>
                </div>
                <div className="info-row">
                  <div className="label text-uppercase">Phone Number</div>
                  <div className="info">{data.chat.user_info.phone || "-"}</div>
                </div>
              </React.Fragment>
            )}
            {data.chat?.teleconsult_on_demand_id &&
              !data.chat.appointment_info.is_me && (
                <>
                  <div className="info-row">
                    <div className="label text-uppercase">
                      Provider (Main User)
                    </div>
                    <div className="info">
                      {data.chat.payment.payer.fullname}
                    </div>
                  </div>

                  <div className="info-row">
                    <div className="label text-uppercase">Relationship</div>
                    <div className="info">
                      {data.chat.appointment_info.visitor.relationship}
                    </div>
                  </div>
                </>
              )}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
}

export default AccordianPatientInformation;
